import { BlurView } from "expo-blur";
import React from "react";
import { View, Text, ScrollView } from "react-native";
import { IconButton, MD3Colors, Tooltip } from "react-native-paper";
import { SingleSelectDropdown } from "../common/controls/Dropdown-filter";
import ButtonControl from "../common/controls/Button";

interface FilterIconProps {
  FilterVisible: boolean;
  setFilterVisible: (val: boolean) => void;
}
const FilterIcon: React.FC<FilterIconProps> = ({ FilterVisible, setFilterVisible }) => {
  return null
  return (
    <Tooltip title="Filter Options">
      <IconButton
        style={{}}
        icon="view-grid-outline"
        iconColor={'#004876'}
        size={20}
        onPress={() => setFilterVisible(!FilterVisible)}
      />
    </Tooltip>
  )
}
interface ExportIconProps {
  newData: any;
  handleExportClick: (val: any) => void;
}
const ExportIcon: React.FC<ExportIconProps> = ({ newData, handleExportClick }) => {
  return null
  return (
    <Tooltip title="Export all to excel">
      <IconButton
        style={{}}
        icon="export-variant"
        iconColor={'#004876'}
        size={20}
        onPress={() => handleExportClick(newData)}
      />
    </Tooltip>
  )
}
interface FilterBoxProps {
  FilterVisible: any;
  setFilterVisible: any;
  screenWidth: number;
  CommonStyles: any;
  yearFilterOptions?: any;
  handleYearFilterSelect: any;
  selectedYear: any;
  monthFilterOptions?: any;
  handleMonthFilterSelect: any;
  selectedMonth: any;
  packageFilterOptions: any;
  handlePackageFilterSelect: any;
  selectedPackage: any;
  handleFilterReset: any;
  setSelectedMonth: any;
  setSelectedYear: any;
  setSelectedPackage: any;
  setNewData: any;
  updatedData: any;
}
const FilterBox: React.FC<FilterBoxProps> = ({
  setFilterVisible, FilterVisible, screenWidth, CommonStyles,
  yearFilterOptions, handleYearFilterSelect, selectedYear,
  monthFilterOptions, handleMonthFilterSelect, selectedMonth,
  packageFilterOptions, handlePackageFilterSelect, selectedPackage,
  handleFilterReset, setSelectedMonth, setSelectedYear, setSelectedPackage, setNewData, updatedData
}) => {
  return (
    <BlurView intensity={80} style={{ flex: 1, padding: 100, justifyContent: 'center', }}>
      <View>
        <Tooltip title="Close">
          <IconButton
            style={{ marginLeft: screenWidth - 60 }}
            icon="close-circle-outline"
            iconColor={MD3Colors.error0}
            size={20}
            onPress={() => setFilterVisible(!FilterVisible)}
          />
        </Tooltip>
      </View>

      <View style={[CommonStyles.container]} key={0}>
        {yearFilterOptions && <View style={[CommonStyles.filterDropdown, CommonStyles.filterCard]}>
          <View style={{ width: '100%' }}><Text style={{ color: '#004876' }}>{'Filter by Year'}</Text></View>
          <SingleSelectDropdown
            options={yearFilterOptions}
            label={"Filter by Year"}
            onSelect={handleYearFilterSelect}
            selected={selectedYear}
          /></View>}
        {monthFilterOptions && <View style={[CommonStyles.filterDropdown, CommonStyles.filterCard]}>
          <View style={{ width: '100%' }}><Text style={{ color: '#004876' }}>{'Filter by Month'}</Text></View>
          <SingleSelectDropdown
            options={monthFilterOptions}
            label={"Filter by Month"}
            onSelect={handleMonthFilterSelect}
            selected={selectedMonth}
          /></View>}
        <View style={[CommonStyles.filterDropdown, CommonStyles.filterCard]}>
          <View style={{ width: '100%' }}><Text style={{ color: '#004876' }}>{'Filter by Package'}</Text></View>
          <SingleSelectDropdown
            options={packageFilterOptions}
            label={"Filter by Package"}
            onSelect={handlePackageFilterSelect}
            selected={selectedPackage}
          />
          {/* <CommonMultiSelectDropdown
            options={packageFilterOptions}
            label={"Filter by Package"}
            onSelect={handlePackageFilterSelect}
            selected={selectedPackage}
          /> */}
        </View>

      </View>
      <View style={[CommonStyles.container, { alignContent: 'center', alignSelf: 'center', flex: 1, flexDirection: 'row', gap: 10 }]}>
        <ButtonControl icon="arrow-left" mode="contained"
          onPress={() => { handleFilterReset(setSelectedMonth, setSelectedYear, setSelectedPackage, setNewData, updatedData); setFilterVisible(false) }}
          Title='Clear' disabled={false} />
        <ButtonControl icon="filter-check" mode="contained"
          onPress={() => { setFilterVisible(!FilterVisible) }}
          Title=' Ok ' disabled={false} />
      </View>
    </BlurView>
  )
}
const IconsContainer = () => {
  return (
    <View style={{ flexDirection: 'row' }}>

    </View>
  )
}

interface SelectedFiltersProps {
  selectedYear?: string;
  selectedMonth?: string;
  selectedPackage?: string;
  cardTitle?: string;
  number?: number;
}
const SelectedFilters: React.FC<SelectedFiltersProps> = ({ selectedYear, selectedMonth, selectedPackage, cardTitle, number }) => {
  return null
  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false}>
      <View style={{ flexDirection: 'row', flex: 1, gap: 20, alignSelf: 'center' }}>
        {selectedYear && <View><Text style={{ fontWeight: 'bold' }}>{'Selected Year: '}<Text style={{ fontWeight: 'normal' }}>{selectedYear}</Text></Text></View>}
        {selectedMonth && <View><Text style={{ fontWeight: 'bold' }}>{'Selected Month: '}<Text style={{ fontWeight: 'normal' }}>{selectedMonth}</Text></Text></View>}
        {selectedPackage && <View><Text style={{ fontWeight: 'bold' }}>{'Selected Package: '}<Text style={{ fontWeight: 'normal' }}>{selectedPackage}</Text></Text></View>}
        {/* {cardTitle && number && <View style={{justifyContent:"center", borderWidth:2, borderColor:'blue'}}><Text style={{ fontWeight: 'bold' }}>{cardTitle+ ': '+ Math.round(number)}</Text></View>} */}
      </View>
    </ScrollView>
  )
}

const FilterBoxFlat: React.FC<FilterBoxProps> = ({
  setFilterVisible,
  FilterVisible,
  screenWidth,
  CommonStyles,

  yearFilterOptions,
  handleYearFilterSelect,
  selectedYear,

  monthFilterOptions,
  handleMonthFilterSelect,
  selectedMonth,

  packageFilterOptions,
  handlePackageFilterSelect,
  selectedPackage,
}) => {
  return (
    <View>
      {/* Filters in one line */}
      <View style={[styles.filtersRow, CommonStyles.container]}>
        {yearFilterOptions?.length ? (
          <View style={[styles.filterItem, CommonStyles.filterCard]}>
            <Text style={styles.label}>{'Year'}</Text>
            <SingleSelectDropdown
              options={yearFilterOptions}
              label={"Filter by Year"}
              onSelect={handleYearFilterSelect}   // applies immediately
              selected={selectedYear}
            />
          </View>
        ) : null}

        {monthFilterOptions?.length ? (
          <View style={[styles.filterItem, CommonStyles.filterCard]}>
            <Text style={styles.label}>{'Month'}</Text>
            <SingleSelectDropdown
              options={monthFilterOptions}
              label={"Filter by Month"}
              onSelect={handleMonthFilterSelect}  // applies immediately
              selected={selectedMonth}
            />
          </View>
        ) : null}

        <View style={[styles.filterItem, CommonStyles.filterCard]}>
          <Text style={styles.label}>{'Package'}</Text>
          <SingleSelectDropdown
            options={packageFilterOptions}
            label={"Filter by Package"}
            onSelect={handlePackageFilterSelect} // applies immediately
            selected={selectedPackage}
          />
        </View>
      </View>
    </View>
  );
};

const styles = {
  overlay: {
    flex: 1,
    paddingHorizontal: 24,
    paddingVertical: 20,
    justifyContent: "flex-start",
  },
  headerRow: {
    flexDirection: "row" as const,
    alignItems: "center" as const,
    justifyContent: "flex-end" as const,
    marginBottom: 12,
  },
  filtersRow: {
    flexDirection: "row" as const,
    alignItems: "flex-start" as const,
    flexWrap: "wrap" as const, // stays single line when space allows, wraps when not
    gap: 12,
  },
  filterItem: {
    flexGrow: 1,
    flexBasis: 260,      // each dropdown “wants” ~260px
    minWidth: 220,       // don’t collapse too small
    padding: 12,
  },
  label: {
    color: "#004876",
    marginBottom: 8,
    fontWeight: "600" as const,
  },
};


export { FilterIcon, ExportIcon, IconsContainer, FilterBox, SelectedFilters, FilterBoxFlat }